<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="5" style="text-align: center">单筐包装材料情况</b-th>
          <b-th colspan="5" style="text-align: center">可利用情况</b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(packWeight)="data">
        {{ Number(data.item.packWeight).toFixed(4) }}
      </template>
      <template v-slot:cell(totalWeight)="data">
        {{ Number(data.item.totalWeight).toFixed(4) }}
      </template>

      <template v-slot:cell(packModel)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.packModel)">{{ data.item.packModel }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
<!--      <template v-slot:foot()="scope">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center'}"></div>-->
<!--      </template>-->
<!--      <template v-slot:foot(packName)="data">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">重量小计</div>-->
<!--      </template>-->
<!--      <template v-slot:foot(totalWeight)="data">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'totalWeight') }}</div>-->
<!--      </template>-->
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "ItsStockPrecoolInBoundDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'packName', label: '材料名称', width: '120px'},
        {key: 'packModel', label: '规格', width: '120px'},
        {key: 'packWeight', label: '单重（斤）', width: '120px'},
        {key: 'num', label: '数量', width: '120px'},
        {key: 'useTypeLabel', label: '利用类型', width: '120px'},
        {key: 'perBasketNum', label: '单筐材料数量', width: '120px'},
        {key: 'totalNum', label: '原料果出库累计数量', width: '120px'},
        {key: 'totalUseNum', label: '本次利用数量', width: '120px'},
        {key: 'remainUseNum', label: '剩余可利用数量', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
    let type = this.$route.query.type
    if(type === 'wash') {
      this.fields1[7].label  = '原料果库中累计数量'
    } else {
      this.fields1[7].label  = '原料果出库累计数量'
    }
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(4, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum2(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(0, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum3(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(4, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>